import Quiz from 'Root/App/Quiz'

const DefaultStatus = ({ content, setIsCompleted }) => {
  return (
    <Quiz
      identifier={content.id}
      collectionContent={content}
      setIsCompleted={setIsCompleted}
    />
  )
}

export default DefaultStatus
